export const DFE_BASE_PATH = "/empresas/direccion-de-innovacion-financiera";
export const DFE_PLANES_PATH = `${DFE_BASE_PATH}/planes`;
export const DFE_DIAGNOSTICO_PATH = `${DFE_BASE_PATH}/diagnostico`;
export const DFE_PDF_PATH = "/portafolio-direccion-de-innovacion-financiera.pdf";
export const DFE_PRINT_PATH = "/portafolio-direccion-de-innovacion-financiera-print.html";

/** Rutas anteriores — mantener redirects en App.js */
export const DFE_LEGACY_BASE_PATH = "/empresas/direccion-financiera-externa";
